var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { dAxios, YNOpTrs } from 'consts';
import { HOST } from 'config';
import { ButtonContain } from 'component/material/ButtonContained/Button';
import { ButtonBar } from 'component/material/ButtonContained/ButtonBar';
import Input, { GreenCheck } from 'component/material/Input';
import { useSnackbar } from 'notistack';
import { browserName } from 'react-device-detect';
import Radio from 'component/material/Radio';
import { useDispatch } from 'react-redux';
import { setLoadingRedux } from 'reducers/sharedata/action';
import { MasterGrids2, PlainText } from 'component/LHH/MasterGrids/MasterGrids';
import InputEngNum, { EngNumCheck } from 'component/material/Input/InputEngNum';
import InputPin, { PinCheck } from 'component/material/Input/InputPin';
import { PageTypeEnum } from 'reducers/sharedata/types';
import { inputChange, radioChange } from 'component/consts';
import { WebSocketTest } from './WebSocketFunc';
// eslint-disable-next-line @typescript-eslint/no-var-requires
var mainStyle = require('main_style.module.css');
// component --------------------------------------------------------------------------
var Authentication = function (props) {
    var dispatch = useDispatch();
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var onDlg = props.onDlg, actinoType = props.actinoType, _a = props._authData, authData = _a[0], setAuthData = _a[1], signSuccess = props.signSuccess, certSuccess = props.certSuccess, handleNext = props.handleNext, // for Register
    setPageShow = props.setPageShow;
    var _b = useState(false), verifyError = _b[0], setVerifyError = _b[1];
    var _c = useState(React.createElement(React.Fragment, null)), machineStatus = _c[0], setMachineStatus = _c[1];
    var _d = useState(false), machineReady = _d[0], setMachineReady = _d[1];
    var _e = useState(''), idNoMsg = _e[0], setIdNoMsg = _e[1];
    var _f = useState(''), idPasswordMsg = _f[0], setIdPasswordMsg = _f[1];
    var updateData = function (updateObj) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setAuthData(function (prev) { return (__assign(__assign({}, prev), updateObj)); });
            return [2 /*return*/];
        });
    }); };
    var idNoOnChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.target.value = e.target.value.toUpperCase();
                    inputChange(updateData)(e);
                    if (!(actinoType === 'Register' && e.target.value.length === 10)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dAxios('get', HOST + "v1/user/id-no", {
                            userType: 'EZWAY',
                            idNo: e.target.value,
                            lang: 'TW',
                        }, enqueueSnackbar)];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data.status) === 'N') {
                        setIdNoMsg(response.data.msg);
                        return [2 /*return*/];
                    }
                    _a.label = 2;
                case 2:
                    setIdNoMsg('');
                    return [2 /*return*/];
            }
        });
    }); };
    var checkCardStatus = function (next) {
        if (next === void 0) { next = false; }
        dispatch(setLoadingRedux(1));
        var params = {
            slot: '0',
            type: '2',
        };
        WebSocketTest('cert', function (ws) { return function () {
            ws.send(JSON.stringify(params));
        }; }, function (ws) { return function (evt) {
            var obj = JSON.parse(evt.data);
            setMachineReady(obj.success);
            setMachineStatus(obj.success ? (React.createElement(PlainText, null, "\u8B80\u5361\u6A5F\u6E96\u5099\u5B8C\u6210")) : (React.createElement("span", { style: { color: 'red' } }, obj.messages[0])));
            // login 成功後將資料存進 certInfo
            if (next && certSuccess && obj.success && obj.data.certInfo) {
                certSuccess(obj.data.certInfo);
            }
            ws.close();
            dispatch(setLoadingRedux(-1));
        }; }, function (ws) { return function (error) {
            // IE 於 readyState === 2 必進 error，但並不是 error
            if (browserName === 'IE' && ws.readyState === 2) {
                return;
            }
            if (process.env.REACT_APP_DEBUG_MODE === 'ON') {
                // eslint-disable-next-line no-console
                console.log("Error code=" + ws.readyState + "," + error);
            }
            dispatch(setLoadingRedux(-1));
        }; });
    };
    var submitCheck = function () {
        setVerifyError(true);
        if (!(((authData.certificateType === 'C' && PinCheck(authData.idNo)) ||
            (authData.certificateType === 'R' && EngNumCheck(authData.idNo))) &&
            authData.idNo.length === 10 &&
            idNoMsg.length === 0) ||
            (!authData.idPassword && idPasswordMsg.length === 0)) {
            return false;
        }
        return true;
    };
    var cardLogin = function () {
        dispatch(setLoadingRedux(1));
        var params = {
            slot: '0',
            type: '2',
            pin: authData.idPassword,
            data: 'A',
        };
        WebSocketTest('P7_Sign', function (ws) { return function () {
            ws.send(JSON.stringify(params));
        }; }, function (ws) { return function (evt) {
            var obj = JSON.parse(evt.data);
            if (!obj.success) {
                if (obj.messages[0] === '憑證密碼錯誤') {
                    setIdNoMsg(obj.messages[0]);
                }
                else if (obj.messages[0].indexOf('登入失敗') > -1) {
                    setIdPasswordMsg(obj.messages[0]);
                }
                else {
                    setMachineStatus(React.createElement("span", { style: { color: 'red' } }, obj.messages[0]));
                    setMachineReady(false);
                }
            }
            else if (obj.data.citizenID === authData.idNo.substr(-4)) {
                signSuccess();
                // setUserForm data
                if (actinoType === 'Register' && handleNext) {
                    checkCardStatus(true);
                    dispatch(setLoadingRedux(-1));
                    ws.close();
                    return;
                }
                // for RealName
                if (actinoType === 'RealName' && setPageShow) {
                    setPageShow(PageTypeEnum.detail);
                }
            }
            else {
                setIdNoMsg('請輸入正確的身分證號碼');
            }
            dispatch(setLoadingRedux(-1));
            ws.close();
        }; }, function (ws) { return function (error) {
            // IE 於 readyState === 2 必進 error，但並不是 error
            if (browserName === 'IE' && ws.readyState === 2) {
                return;
            }
            if (process.env.REACT_APP_DEBUG_MODE === 'ON') {
                throw new Error("Error code=" + ws.readyState + "," + error);
                // eslint-disable-next-line no-console
                // console.log(`Error code=${ws.readyState},${error}`);
            }
            dispatch(setLoadingRedux(-1));
        }; });
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (e && e.preventDefault) {
                e.preventDefault();
            }
            if (!submitCheck()) {
                return [2 /*return*/];
            }
            cardLogin();
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        checkCardStatus();
    }, []);
    var QueryConds = [
        { t: '讀卡機狀態', child: machineStatus },
        {
            t: '持有證件',
            child: (React.createElement(Radio, { required: true, verifyBeforeChange: verifyError, disabled: authData.idNoDisable, name: "certificateType", value: authData.certificateType || '', onChange: function (e, value) {
                    var updateObj = radioChange()(e, value);
                    // 切換時檢查 idNo 不合邏輯時應清空
                    if ((value === 'C' && !PinCheck(authData.idNo)) ||
                        (value === 'R' && !EngNumCheck(authData.idNo))) {
                        updateObj.idNo = '';
                    }
                    updateData(updateObj);
                }, options: [
                    { value: 'C', label: '身分證' },
                    { value: 'R', label: '居留證' },
                ] })),
        },
        {
            t: (React.createElement(React.Fragment, null,
                "\u662F\u5426\u70BA\u5927\u9678\u5730\u5340",
                React.createElement("br", null),
                "\u53CA\u9999\u6E2F\u6FB3\u9580\u4EBA\u6C11")),
            show: authData.certificateType === 'R',
            child: (React.createElement(Radio, { required: true, verifyBeforeChange: verifyError, disabled: authData.idNoDisable, name: "isChina", value: authData.isChina || '', onChange: radioChange(updateData), options: YNOpTrs.options })),
        },
        {
            t: authData.certificateType === 'C' ? '身分證號碼' : '居留證號碼',
            child: authData.certificateType === 'C' ? (React.createElement(InputPin, { className: mainStyle.input, required: true, verifyBeforeChange: verifyError, disabled: authData.idNoDisable, InputProps: idNoMsg.length === 0 &&
                    authData.idNo.length === 10 &&
                    PinCheck(authData.idNo)
                    ? { endAdornment: React.createElement(GreenCheck, null) }
                    : {}, error: idNoMsg.length > 0, helperText: idNoMsg, placeholder: "\u8ACB\u8F38\u5165\u5E33\u865F\u64C1\u6709\u8005\u7684\u8EAB\u5206\u8B49\u865F\u78BC", value: authData.idNo || '', name: "idNo", onChange: idNoOnChange })) : (React.createElement(InputEngNum, { className: mainStyle.input, required: true, verifyBeforeChange: verifyError, minLength: 10, maxLength: 10, disabled: authData.idNoDisable, InputProps: idNoMsg.length === 0 &&
                    authData.idNo.length === 10 &&
                    EngNumCheck(authData.idNo)
                    ? { endAdornment: React.createElement(GreenCheck, null) }
                    : {}, error: idNoMsg.length > 0, helperText: idNoMsg, placeholder: "\u8ACB\u8F38\u5165\u5E33\u865F\u64C1\u6709\u8005\u7684\u5C45\u7559\u8B49\u865F\u78BC", value: authData.idNo || '', name: "idNo", onChange: idNoOnChange })),
        },
        {
            t: 'PIN 碼',
            child: (React.createElement(React.Fragment, null,
                React.createElement(Input, { className: mainStyle.input, required: true, verifyBeforeChange: verifyError, error: idPasswordMsg.length > 0, helperText: idPasswordMsg, placeholder: "\u8ACB\u8F38\u5165 PIN \u78BC", type: "password", name: "idPassword", value: authData.idPassword, onChange: function (e) {
                        setIdPasswordMsg('');
                        inputChange(updateData)(e);
                    } }),
                React.createElement("div", { style: { margin: '8px 0 5px' } },
                    React.createElement("a", { href: "https://moica.nat.gov.tw/faq_in_c_18_1.html", target: "_blank", rel: "noreferrer" }, "\u5982\u4F55\u53D6\u5F97\u81EA\u7136\u4EBA\u6191\u8B49\uFF1F")),
                React.createElement("div", null,
                    React.createElement("a", { href: "https://moica.nat.gov.tw/unblockcard.html", target: "_blank", rel: "noreferrer" }, "\u5FD8\u8A18 PIN \u78BC\u600E\u9EBC\u8FA6\uFF1F")))),
        },
    ];
    return (React.createElement("div", null,
        React.createElement("div", { style: { marginBottom: 10 } }, "\u9A57\u8B49\u65B9\u5F0F\uFF1A\u81EA\u7136\u4EBA\u6191\u8B49\u5361\u3001\u8B80\u5361\u6A5F"),
        React.createElement("form", { onInvalid: function () { return setVerifyError(true); }, onSubmit: handleSubmit },
            React.createElement(MasterGrids2, { mGrids: QueryConds, md: [3, 9] }),
            React.createElement(ButtonBar, { style: onDlg ? { paddingBottom: 0 } : {} },
                React.createElement(ButtonContain, { onClick: function () { return checkCardStatus(); } }, "\u91CD\u65B0\u6AA2\u6E2C"),
                React.createElement(ButtonContain, { type: "submit", color: "secondary", disabled: !machineReady }, "\u57F7\u884C\u8EAB\u5206\u9A57\u8B49")))));
};
export default Authentication;
